var _path, _path2, _g, _path3, _path4, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoLocationCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 23.5817 3.58172 20 8 20L48 20C52.4183 20 56 23.5817 56 28L56 49C56 53.4183 52.4183 57 48 57L8 57C3.58172 57 0 53.4183 0 49L0 28Z",
    fill: "#D0D7E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5569_24558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 56,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 23.5817 3.58172 20 8 20L48 20C52.4183 20 56 23.5817 56 28L56 49C56 53.4183 52.4183 57 48 57L8 57C3.58172 57 0 53.4183 0 49L0 28Z",
    fill: "#D0D7E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5569_24558)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7464 11.8412C48.8007 11.0435 52.7983 10.1793 54.6653 9.84696C62.4628 11.8412 79.0463 21.879 83 46.0761C76.0811 46.0761 79.3758 53.0561 78.7169 56.7122C77.1616 65.3415 73.006 59.5928 71.4684 55.7151C70.8095 50.7294 67.383 46.4085 64.22 47.738C61.0571 49.0675 55.6537 47.1841 53.3474 46.0761C51.4804 45.633 48.2735 45.3449 50.3822 47.738C52.4908 50.1311 55.6537 51.1726 56.9716 51.3942C62.1334 52.3913 62.5727 55.3827 55.6537 57.377C39.9252 61.9105 38.1917 45.7438 38.5211 43.0847C38.7847 40.9575 33.7987 38.8746 31.2727 38.0991C26.6601 35.1077 29.6254 32.4486 31.2727 31.7839C33.0565 31.0641 37.2032 32.781 38.5211 30.4544C39.5754 28.5931 38.3015 27.6846 37.5327 27.463C36.3246 27.1306 32.8542 27.463 28.6369 31.4515C23.3654 36.4372 18.0938 29.7896 17.7643 29.4572C17.4349 29.1249 16.4464 27.7954 14.7991 28.1277C13.4812 28.3936 11.8338 28.2385 11.1749 28.1277C9.52751 27.7954 9.85698 26.1335 10.8454 25.1363C11.7773 24.1962 16.0071 22.9205 18.0938 22.4773C20.6198 22.3665 26.3965 21.1478 29.2959 17.1593C32.1952 13.1707 37.5327 11.952 39.839 11.8412C42.0355 12.1736 46.6921 12.6389 47.7464 11.8412Z",
    fill: "#29315D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53909 18.1564C6.43046 17.3587 6.12295 14.9434 6.23278 13.8355C12.3825 8.84983 24.7479 0.340958 25.0115 6.19081C25.341 13.5031 21.3873 18.8212 17.7643 16.4945C14.1414 14.1679 12.821 16.4945 12.4915 16.4945C12.1621 16.4945 11.1749 19.1535 8.53909 18.1564Z",
    fill: "#29315D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59576 28.4596C-0.358908 28.1937 -3.76289 32.1157 -4.97054 34.11C-6.02486 34.6418 -6.06879 35.8827 -5.95896 36.4366C-5.4318 37.7662 -4.20177 36.9906 -3.65265 36.4366C-3.32318 35.6611 -1.74171 34.3094 1.94839 35.1071C5.63849 35.9048 7.00031 34.11 7.21996 33.1129C7.65967 31.6726 7.55042 28.7255 3.59576 28.4596Z",
    fill: "#29315D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5005 38.1792L59.039 38.1797",
    stroke: "#D0D7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6836 17.2129L48.6836 56.2129",
    stroke: "#D0D7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 17.2129L40.5 56.2129",
    stroke: "#D0D7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5005 24.4819L59.039 24.4824",
    stroke: "#D0D7E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5005 50.5015L59.039 50.5019",
    stroke: "#D0D7E2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62962 51.2984C8.32854 50.7666 10.9786 50.1905 12.2163 49.9689C17.3855 51.2984 28.379 57.9903 31 74.1217C26.4133 74.1217 28.5974 78.775 28.1606 81.2124C27.1296 86.9653 24.3747 83.1329 23.3555 80.5477C22.9187 77.2239 20.6471 74.3433 18.5504 75.2296C16.4536 76.116 12.8716 74.8603 11.3427 74.1217C10.105 73.8263 7.97908 73.6342 9.37694 75.2296C10.7748 76.8251 12.8716 77.5194 13.7452 77.6671C17.1671 78.3318 17.4583 80.3261 12.8716 81.6556C2.44479 84.6779 1.2956 73.9001 1.51401 72.1275C1.68874 70.7093 -1.6166 69.3207 -3.29111 68.8037C-6.34892 66.8094 -4.38319 65.0367 -3.29111 64.5936C-2.10864 64.1137 0.64035 65.2583 1.51401 63.7072C2.21294 62.4663 1.3684 61.8607 0.858765 61.713C0.0579109 61.4914 -2.24273 61.713 -5.03843 64.372C-8.53307 67.6957 -12.0277 63.264 -12.2461 63.0425C-12.4645 62.8209 -13.1198 61.9345 -14.2119 62.1561C-15.0855 62.3334 -16.1776 62.23 -16.6144 62.1561C-17.7065 61.9345 -17.4881 60.8266 -16.8328 60.1619C-16.2151 59.5351 -13.411 58.6846 -12.0277 58.3892C-10.3532 58.3153 -6.52365 57.5028 -4.60161 54.8438C-2.67956 52.1848 0.858765 51.3723 2.38767 51.2984C3.84377 51.52 6.93069 51.8303 7.62962 51.2984Z",
    fill: "#29315D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.3617 55.5086C-19.7596 54.9768 -19.9634 53.3666 -19.8906 52.628C-15.8138 49.3042 -7.61654 43.6316 -7.44181 47.5315C-7.2234 52.4064 -9.84437 55.9517 -12.2461 54.4006C-14.6479 52.8495 -15.5232 54.4006 -15.7416 54.4006C-15.96 54.4006 -16.6144 56.1733 -18.3617 55.5086Z",
    fill: "#29315D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.6388 62.3774C-24.2604 62.2001 -26.517 64.8148 -27.3176 66.1443C-28.0165 66.4988 -28.0456 67.3261 -27.9728 67.6954C-27.6233 68.5817 -26.8079 68.0647 -26.4439 67.6954C-26.2255 67.1784 -25.1771 66.2773 -22.7308 66.8091C-20.2846 67.3409 -19.3818 66.1443 -19.2362 65.4795C-18.9447 64.5193 -19.0171 62.5546 -21.6388 62.3774Z",
    fill: "#29315D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-5.22217 54.3081L29.3164 54.3086",
    stroke: "#D0D7E2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9335 6.44955C35.7824 9.29849 37.3829 13.1625 37.3829 17.1915C37.3829 21.2205 35.7824 25.0845 32.9335 27.9335L24.7228 36.1441C23.3248 37.5421 21.0582 37.5421 19.6602 36.1441L11.4495 27.9334C8.60052 25.0844 7 21.2204 7 17.1914C7 13.1624 8.60052 9.29841 11.4495 6.44947C14.2984 3.60051 18.1624 2 22.1915 2C26.2205 2 30.0845 3.60057 32.9335 6.44955Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2.85226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2344 17.64C16.2344 14.3493 18.902 11.6816 22.1927 11.6816C25.4835 11.6816 28.1511 14.3493 28.1511 17.64C28.1511 20.9307 25.4835 23.5984 22.1927 23.5984C18.902 23.5984 16.2344 20.9307 16.2344 17.64Z",
    fill: "#FCFAF9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 23.639,
    cy: 44.3051,
    rx: 7.44756,
    ry: 2.6938,
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoLocationCheckLarge);
export default __webpack_public_path__ + "static/media/geo_location_check_large.201f099d688941ab8d39c73aeec61128.svg";
export { ForwardRef as ReactComponent };